import styles from "./SeedItem.module.css";
import { getInitials, SeedType } from "../../utils/common";
import { useNavigate } from "react-router-dom";
import React from "react";
import Avatar from "../../design-system/Avatar";
import "react-quill/dist/quill.snow.css";
import { Card, CardHeader, CardBody, Tooltip } from "@material-tailwind/react";
import ShowPublishedExclusiveItemInSeedSearch from "./ShowPublishedExclusiveItemInSeedSearch";
import ShowPodcastItemInSeedSearch from "./ShowPodcastItemInSeedSearch";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";
import { markdownComponents } from "../../pages/thoughts/chat/RenderResponse";
import BookPodcastItemInSeedSearch from "./BookPodcastItemInSeedSearch";

export interface SeedItemProps {
    seed: SeedType;
}

const SeedHeader = ({ seed }: SeedItemProps) => {
    function getNumberOfDaysSinceTimestamp(timestamp: string | number): string {
        const inputDate = new Date(timestamp);
        const currentDate = new Date();
        inputDate.setHours(0, 0, 0, 0);
        currentDate.setHours(0, 0, 0, 0);
        currentDate.setDate(currentDate.getDate());

        const differenceInTime = currentDate.getTime() - inputDate.getTime();
        const differenceInDays = Math.ceil(differenceInTime / (1000 * 3600 * 24));
        let result = "";
        if (differenceInDays === 1 || differenceInDays === 0) {
            result += `${differenceInDays} day`;
        } else {
            result += `${differenceInDays} days`;
        }

        return result;
    }

    const initials = getInitials(seed.author);

    return (
        <div className={`${styles.header} p-1 text-gray-700`}>
            <div className="flex items-center">
                <Tooltip content={seed.author} className="bg-neutral-600 w-fit h-7 text-center p-1  top-full left-0 z-50" placement="right">
                    <div>
                        <Avatar initials={initials} className="mr-2" />
                    </div>
                </Tooltip>
            </div>
            <span className={`justify-self-center truncate w-full max-w-full text-gray-500`}>{seed.date}</span>
            <h2 className={`justify-self-center font-title truncate w-full max-w-full`} title={seed.title}>
                {seed.title}
            </h2>
        </div>
    );
};

const SeedBody = ({ seed }: SeedItemProps) => {
    return (
        <div className="p-2 overflow-y-auto   leading-7">
            {seed.brief_summary && (
                <ReactMarkdown rehypePlugins={[rehypeRaw]} remarkPlugins={[remarkGfm]} components={markdownComponents}>
                    {seed.brief_summary}
                </ReactMarkdown>
            )}
        </div>
    );
};

export const SeedItem = ({ seed, index, onCitationClick }: SeedItemProps & { index?: number } & {onCitationClick:any}) => {
    return (
        <>
            {!seed.private && seed.mediaType === "blog" ? (
                <a href={seed.link} target="_blank" className="text-blue-700 cursor-pointer">
                    {/* <Card className="mt-6 cursor-pointer hover:cursor-pointer pb-4"> */}
                    <div className="my-2">
                        <CardHeader className="relative">
                            <SeedHeader seed={seed} />
                        </CardHeader>
                        {/* <CardBody className="p-2">
                            <SeedBody seed={seed} />
                        </CardBody> */}
                        {/* </Card> */}
                    </div>
                </a>
            ) : seed.mediaType === "exclusive_content" ? (
                <ShowPublishedExclusiveItemInSeedSearch key={seed.id} draft={seed} onCitationClick={onCitationClick}></ShowPublishedExclusiveItemInSeedSearch>
            ) : seed.mediaType === "podcast" || seed.mediaType === "sps_podcast" ? (
                <ShowPodcastItemInSeedSearch seed={seed} onCitationClick={onCitationClick}></ShowPodcastItemInSeedSearch>
            ) : (
                seed.mediaType === "books" && (
                    // <div>dgv</div>
                    <BookPodcastItemInSeedSearch seed={seed} onCitationClick={onCitationClick}></BookPodcastItemInSeedSearch>
                )
            )}
        </>
    );
};
